import { PlusOutlined } from '@ant-design/icons'
import { Table } from 'antd'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { Button, Input } from 'src/common'
import { SearchIcon } from 'src/components/Icon'
import { ShareSelectInput } from 'src/components/shared'
import { ExpandedRowRender } from './expandableRower'
import { useListCartsTable } from './useListCartsTable'
import { useAppSelector } from '@redux'

const ListCartsTable = () => {
  const {
    carts,
    columns,
    searchString,
    setSearchString,
    getListCarts,
    isGettingCarts,
    handleClear,
    eventGuid,
    setEventGuid,
    setEventSearchString,
    listEventOption,
    handleScroll,
    isGettingEvent,
  } = useListCartsTable()

  const totalCarts = useAppSelector((state) => state.carts.totalCart)
  const currentPage = useAppSelector((state) => state.carts.currentPage)

  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>(
    carts.map((d) => d.userId)
  )
  useEffect(() => {
    const a = carts.map((d) => d.userId)
    setExpandedKeys(a)
  }, [JSON.stringify(carts)])
  return (
    <>
      <div className="flex items-center justify-between py-[1.25rem] w-full">
        <div className="flex items-center gap-x-4 w-fit">
          <Input
            className="pl-5 !h-10 "
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            containerClassName="!w-[400px]"
            placeholder={t('evolveLanding:search_carts')}
            prefix={<SearchIcon className="pl-2" />}
          />
          <ShareSelectInput
            containerClassName="flex flex-col gap-[10px]"
            className="!w-[300px] gap-x-4"
            inlineLabelClassName="!text-start !block !m-0"
            placeholder="Filter by event"
            options={listEventOption}
            onChange={(value: any) => {
              setEventGuid(value)
            }}
            loading={isGettingEvent}
            value={eventGuid as any}
            showSearch
            showArrow
            onPopupScroll={handleScroll}
            onSearch={(val) => setEventSearchString(val)}
          />
        </div>
        <div className="flex gap-x-2">
          <Button
            htmlType="submit"
            type="primary"
            size="middle"
            className="!bg-red-500 !border-none h-10"
            style={{
              alignSelf: 'flex-end',
            }}
            onClick={handleClear}
          >
            {'Clear filter'}
          </Button>
        </div>
      </div>
      <Table
        scroll={{ x: 1000 }}
        rowKey={(record) => record.userId}
        columns={columns}
        dataSource={carts?.map((item: any, index: any) => {
          return {
            ...item,
            key: item?.id,
          }
        })}
        loading={isGettingCarts}
        expandable={{
          expandedRowRender: (record, index) => {
            return <ExpandedRowRender data={record.items} searchString={searchString} />
          },
          rowExpandable: (record) => record.items.length > 0,
          expandedRowKeys: expandedKeys,
          onExpand: (expanded, record) => {
            setExpandedKeys((prev) =>
              expanded
                ? [...prev, record.userId]
                : prev.filter((key) => key !== record.userId)
            )
          },
        }}
        pagination={{
          pageSize: 10,
          current: currentPage,
          total: totalCarts,
          onChange: (page) => {
            getListCarts({ page: page, limit: 10 })
          },
        }}
      />
    </>
  )
}

export default ListCartsTable
